import React, { useEffect, useMemo, useState } from "react";
import { Navigate } from "react-router-dom";

import { RBAC_STORAGE_KEYS } from "@cyngn/auth-react";

import { LoginComponent } from "Components/Authentication/Login.component";
import { ForgotPasswordComponent } from "Components/Authentication/ForgotPassword.component";
import { useAuth } from "Components/Authentication/AuthProvider";

import { AuthenticationContainer, LoggedInNotify } from "./styles";

export const AuthenticationPage = () => {
  const [showLoggedInNotify, setShowLoggedInNotify] = useState(false);
  const { isAuthenticated } = useAuth();

  useEffect(() => {
    const handleNewSession = (event: StorageEvent) => {
      if (
        event.key === RBAC_STORAGE_KEYS.idToken &&
        event.oldValue === null &&
        event.newValue
      ) {
        setShowLoggedInNotify(true);
      }
    };
    window.addEventListener("storage", handleNewSession);
    return () => {
      window.removeEventListener("storage", handleNewSession);
    };
  }, []);

  const [authStage, setAuthStage] = useState("INIT");

  const handleCancel = () => {
    setAuthStage("INIT");
  };

  const handleForgotPass = () => {
    setAuthStage("FORGOT");
  };

  const authenticationContent = useMemo(() => {
    if (isAuthenticated) {
      return <Navigate to="/" replace={true} />;
    } else if (authStage === "INIT") {
      return <LoginComponent onForgotSelected={handleForgotPass} />;
    } else if (authStage === "FORGOT") {
      return <ForgotPasswordComponent onCancel={handleCancel} />;
    } else return null;
  }, [authStage, isAuthenticated]);

  return (
    <AuthenticationContainer>
      {showLoggedInNotify && (
        <LoggedInNotify>
          You signed in with another tab or window. Reload page to refresh your
          session
        </LoggedInNotify>
      )}
      {authenticationContent}
    </AuthenticationContainer>
  );
};
